import styled from "styled-components";

export const Thead = styled.thead`
    display: table-header-group;
    break-inside: avoid;
    color: ${props => props.theme.primary};
`;
